import React from 'react'
// import InstallOrLoginOld from './InstallOrLoginOld'
import SlackSignIn from './SlackSignIn'

const SlackSignInDenied = () => <SlackSignIn oauthDenied />

export default SlackSignInDenied



// WEBPACK FOOTER //
// ./src/components/SlackSignInDenied.jsx